import { render, staticRenderFns } from "./user-side-menu.vue?vue&type=template&id=7e70e921"
import script from "./user-side-menu.vue?vue&type=script&lang=js"
export * from "./user-side-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports